export const policySettingItems = [
  { key: "terms-and-conditions", label: "Terms & Conditions" },
  { key: "privacy-policy", label: "Privacy Policy" },
  { key: "disclaimer", label: "Disclaimer" },
  { key: "franchise-policy", label: "Franchise Policy" },
  { key: "code-of-conduct", label: "Code of Conduct" },
  { key: "territorial-policy", label: "Territorial Policy" },
  { key: "refund-cancellation-policy", label: "Refund & Cancellation" },
  { key: "anti-ragging-student-conduct", label: "Anti-Ragging / Conduct" },
  { key: "examination-certification-policy", label: "Examination & Certification" },
  { key: "certificate-verification", label: "Certificate Verification" },
  { key: "affiliation-accreditation", label: "Affiliation & Accreditation" },
  { key: "contact-us", label: "Contact Us" },
  { key: "grievance-redressal", label: "Grievance Redressal" },
];

